import React, { Component } from 'react';
import Helmet from 'react-helmet';
import Image from 'gatsby-image';
import { css } from 'emotion';

import ReactFitText from 'react-fittext';
import ProjectHeadline from '../../components/project/project-hero/project-headline';
import HeroAwkward from '../../components/hero-awkward';
import WebinarModal from '../../components/modal/modal-webinar-employeebranding';

import styles from './webinar.module.css';

class EmployeeBrandingRegisterPage extends Component {
  componentDidMount() {
    this.props.toggleNav(true);
    // this.props.toggleFooter(true);
  }
  componentWillUnmount() {
    this.props.toggleNav(false);
    // this.props.toggleFooter(false);
  }
  render() {
    return (
      <React.Fragment>
        <Helmet>
          <title>Employer Branding | JK Design</title>
          <meta
            name="description"
            content="Where to start, what to do, how to win."
          ></meta>
        </Helmet>
        <WebinarModal />
        <section
          className={css`
            position: relative;
            overflow: hidden;
            height: 100%;
            display: grid;
            grid-template-columns: repeat(1, minmax(0, 1fr));
            grid-template-rows: 120px auto auto auto auto auto auto;
            @media (min-width: 769px) {
              grid-template-rows: 293px auto 128px auto auto auto auto;
            }
          `}
        >
          <div
            className={css`
              grid-row-start: 2;
              grid-row-end: 4;
              grid-column-start: 1;
              grid-column-end: 2;
              width: 85%;
              max-width: 1206px;
              margin-right: auto;
              margin-left: auto;
              display: flex;
              align-items: flex-end;
            `}
          >
            <div
              className={css`
                position: relative;
                width: 100%;
                z-index: 1;
                padding-bottom: 5rem;
                @media (min-width: 769px) {
                  padding-bottom: 0;
                  width: 65%;
                }
              `}
            >
              <div>
                <ProjectHeadline
                  headline={
                    'Employer branding: Where to start, what to do, how to win.'
                  }
                  colorOverride="#1605BA"
                  fontOverride="montheavy"
                />
              </div>
            </div>
          </div>
          <div
            className={css`
              grid-column-start: 1;
              grid-column-end: 2;
              grid-row-start: 5;
              grid-row-end: 7;
            `}
          >
            <div
              className={css`
                background: radial-gradient(
                  circle at 100% 0,
                  rgba(241, 49, 158, 1) 0%,
                  rgba(188, 52, 170, 1) 50%,
                  rgba(136, 55, 182, 1) 100%
                );
                height: 100%;
                width: 25%;
                margin-left: auto;
              `}
            ></div>
          </div>
          <div
            className={css`
              position: relative;
              grid-column-start: 1;
              grid-column-end: 2;
              grid-row-start: 4;
              grid-row-end: 7;
              background: radial-gradient(
                circle at 0% 200%,
                #f1319e 0,
                #b563aa 15%,
                #a174ae 32%,
                #8d85b2 50%,
                #7a96b7 66%,
                #3ec8c3 82%,
                #2ad9c7 100%
              );
              width: calc(1105.5px + (100vw - 1206px) / 2);
              @media (min-width: 769px) {
                grid-row-start: 3;
              }
            `}
          ></div>
          <div
            className={css`
              position: relative;
              grid-column-start: 1;
              grid-column-end: 2;
              grid-row-start: 4;
              grid-row-end: 5;
              display: grid;
              grid-template-rows: auto auto 1fr 1fr;
            `}
          >
            <div
              className={css`
                position: relative;
                max-width: 1206px;
                margin-right: auto;
                margin-left: auto;
                width: 85%;
              `}
            >
              <div
                className={css`
                  display: flex;
                `}
              >
                <div
                  className={css`
                    margin-top: 4rem;
                    @media (min-width: 769px) {
                      margin-top: 6.7rem;
                      width: calc(8 / 12 * 100%);
                    }
                  `}
                >
                  <p
                    className={css`
                      font-size: 1.5rem;
                      font-family: 'montsemibold';
                      color: #ffffff;
                    `}
                  >
                    This one-hour webinar shares solutions to help you overcome
                    or avoid some of the most common hurdles that can stand
                    between your company and creating a truly authentic and
                    inspired employer brand.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div
            className={css`
              position: relative;
              grid-column-start: 1;
              grid-column-end: 2;
              grid-row-start: 5;
              grid-row-end: 6;
              display: grid;
              grid-template-rows: auto auto 1fr 1fr;
            `}
          >
            <div
              className={css`
                position: relative;
                max-width: 1206px;
                margin-right: auto;
                margin-left: auto;
                width: 85%;
              `}
            >
              <div
                className={css`
                  display: flex;
                `}
              >
                <div
                  className={css`
                    @media (min-width: 769px) {
                      width: calc(8 / 12 * 100%);
                    }
                  `}
                >
                  <p
                    className={css`
                      font-size: 1rem;
                      color: #ffffff;
                    `}
                  >
                    Click below for thoughtful and effective solutions that will
                    help you build a more powerful talent engagement platform.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div
            className={css`
              grid-column-start: 1;
              grid-column-end: 2;
              grid-row-start: 6;
              grid-row-end: 8;
            `}
          >
            <div className={styles.container}>
              <div
                className={css`
                  margin-top: 4rem;
                  background: black;
                  padding-bottom: calc(9 / 16 * 100%);
                  @media (min-width: 769px) {
                    margin-top: 6rem;
                  }
                `}
              ></div>
            </div>
          </div>
        </section>
      </React.Fragment>
    );
  }
}

export default EmployeeBrandingRegisterPage;



// WEBPACK FOOTER //
// ./src/pages/employerbranding-webinar/register.js